import { usePermissions } from 'react-admin';

/**
 * Права на модерационные действия: admin и moderator.
 * support видит всё, но кнопок действий не имеет (UI-скрытие; настоящая
 * проверка — assertRole на backend).
 */
export function useCanModerate(): boolean {
  const { permissions } = usePermissions();
  return permissions === 'admin' || permissions === 'moderator';
}
